import {ref} from 'vue';
import {defineStore, storeToRefs} from 'pinia';
import {readonlyState} from '@malt/utils';
import {Configuration, MicroConsultingApi} from '@api';
import {useProfileStore} from '~/store/profileStore';

export const useMicroConsultingStore = defineStore('profile-micro-consulting', () => {
    const apiConfiguration = new Configuration({basePath: ''});
    const api = new MicroConsultingApi(apiConfiguration);

    const {profile} = storeToRefs(useProfileStore());

    const isActivated = ref<boolean>();
    const hourlyRate = ref<number>();
    const currency = ref<string>();
    const description = ref<string>();

    // TODO cleanup with FF `enable-micro-consulting-for-all-clients`
    const isClientEligible = ref<boolean>(false);
    const isFreelancerEligible = ref<boolean>(false);
    const freelancerCompanyId = ref<string>();

    async function getMicroConsultingInfo(): Promise<void> {
        const response = await api.getMicroConsultingInfo({profileId: profile.value!.profileId});
        isActivated.value = response.isActive;
        hourlyRate.value = response.hourlyRate;
        currency.value = response.currency;
        description.value = response.description;
    }

    async function getClientEligibility(): Promise<void> {
        const response = await api.getClientEligibility();
        isClientEligible.value = response.isEligible;
    }

    async function getFreelancerEligibility(): Promise<void> {
        const response = await api.getFreelancerEligibility();
        isFreelancerEligible.value = response.isEligible;
        freelancerCompanyId.value = response.freelancerCompanyId;
    }

    return {
        isMicroConsultingActivated: readonlyState(isActivated),
        hourlyRate: readonlyState(hourlyRate),
        currency: readonlyState(currency),
        description: readonlyState(description),
        isClientEligible: readonlyState(isClientEligible),
        isFreelancerEligible: readonlyState(isFreelancerEligible),
        freelancerCompanyId: readonlyState(freelancerCompanyId),
        getMicroConsultingInfo,
        getClientEligibility,
        getFreelancerEligibility,
    };
});
